import axios from "../config/axios-chatbot";


export const VocabularyRepository = {
  getVocabulary: (flowUid) => axios.get(`/api/vocabulary?flow=${flowUid}`),
  getVocabularyByType: (flowUid, type = 'PRONUNCIATION') => axios.get(`/api/vocabulary?flow=${flowUid}&type=${type}`),
  // entries of one sub project (registry projects)
  getSubProjectVocabulary: (subProjectId, type = 'PRONUNCIATION') =>
    axios.get(`/api/vocabulary`, {params: {subProjectId, type}}),
  // every entry of a project: project-wide ones and those of each sub project
  getProjectVocabulary: (projectId, type = 'PRONUNCIATION') =>
    axios.get(`/api/vocabulary`, {params: {projectId, type}}),
  // data: {subProjectId, projectId?, phrase, pronunciation, regex, type} (the flowUid is set from the sub project);
  // only projectId = a project-wide entry. 409 when the owner already has this phrase and type.
  create: (data) => axios.post(`/api/vocabulary`, data),
  // without subProjectId the entry keeps its owner; a subProjectId moves it. If another entry of the owner already
  // has the phrase, that one is overwritten instead - the response is the entry actually saved.
  update: (id, data) => axios.put(`/api/vocabulary/${id}`, data),
  delete: (id) => axios.delete(`/api/vocabulary/${id}`),
  // WAV preview of `text` as a call of the sub project's flow would say it (its voice configuration and
  // PRONUNCIATION entries). options (all optional, empty = the flow's current setting): {voiceModelId, voice,
  // languageCode, speakingRate, pitch, prompt, audioEncoding} - voice / speakingRate / pitch / prompt /
  // audioEncoding apply to Google models only. Errors arrive as a Blob of JSON {error}.
  getAudio: (text, subProjectId, options = {}) => axios.get(`/api/vocabulary/audio`, {
    params: {
      text,
      subProjectId,
      ...Object.fromEntries(Object.entries(options).filter(([, value]) => value !== undefined && value !== null && value !== "")),
    },
    responseType: 'blob',
  }),
  // {flowUid, current: {voiceModelId, voiceModelName, google, voice, languageCode, speakingRate, pitch, audioEncoding},
  //  models: [{voiceModelId, name, provider, modelId, google, isPublic, current}]}
  getVoiceOptions: (subProjectId) => axios.get(`/api/vocabulary/voice-options`, {params: {subProjectId}}),
  // writes the sub project's (and its project's project-wide) PHONEMIZER entries and reloads the TTS service
  reloadPhonemizer: (subProjectId) => axios.post(`/api/vocabulary/${subProjectId}/reload`, {action: "clear_tts_cache"}),
}
